import { Drawer as AntdDrawer, DrawerProps } from 'antd';
import React from 'react';

const Drawer: React.FC<DrawerProps> = (props) => {
    return (
        <AntdDrawer {...props} closeIcon={<div className="ant-btn ant-btn-primary">Close</div>}>
            {props.children}
        </AntdDrawer>
    );
};

export default Drawer;
